import { isNumber, toNumber } from "lodash-es";

export const RouteFactory = {
  home: "/",
  myBT: "/mybt",
  myBTOnboard: "/mybt/onboard",
  myBTIntro: "/mybt/intro",
  budget2024: "/singapore-budget-2024",
  keywordsBudget2024: "/keywords/singapore-budget-2024",
  article: (id: string) =>
    isNumber(toNumber(id)) ? `/article/${id}` : `/${id}`,
  section: (path: string) => `/${path}`,
  keywords: (keyword: string) => `/keywords/${keyword}`,
  search: () => `/search`,
  breakingNews: "/breaking-news",
  aboutUs: "/content/about-us",
  contactUs: "/content/contact-us",
  help: "/help",
  wealth: "/wealth",
  globalEnterprise: "/international/global",
  aseanBusiness: "/international/asean",
  newsletterSignup: "/newsletter/sign-up",
  garage: "/startups-tech/startups",
  sgsme: "/singapore/smes",
  lifestyle: "/lifestyle",
  lifestyleLuxe: "/lifestyle/bt-luxe",
  pr: "/pr",
  advertise: "/advertise",
};

export const isRouteCSROnly = function isRouteCSROnly(path: string): boolean {
  const staticRoutesRegexList = [new RegExp(`^.*${RouteFactory.search()}.*`)];

  return staticRoutesRegexList.some((regex: RegExp) => regex.test(path));
};

export const routesVerticals = [
  RouteFactory.globalEnterprise,
  RouteFactory.aseanBusiness,
  RouteFactory.garage,
  RouteFactory.sgsme,
];

export const routesToExcludeFromSection = [
  RouteFactory.keywords,
  RouteFactory.wealth,
  RouteFactory.lifestyle,
  RouteFactory.lifestyleLuxe,
  ...routesVerticals,
];
